import classNames from 'classnames';
import React from 'react';
import { FaAlignCenter, FaAlignLeft, FaAlignRight } from 'react-icons/fa';

const FontAlignment = ({ align, setAlign }) => {
  return (
    <div className='t-flex t-items-center t-justify-end t-gap-3 t-text-right'>
      <span title='Align Left'>
        <FaAlignLeft
          size={18}
          className={classNames('t-cursor-pointer t-opacity-80 t-transition hover:t-text-primary', {
            't-text-primary t-opacity-100': align === 'left',
            't-text-muted': align !== 'left',
          })}
          onClick={() => setAlign('left')}
        />
      </span>
      <span title='Align Center'>
        <FaAlignCenter
          size={18}
          className={classNames('t-cursor-pointer t-opacity-80 t-transition hover:t-text-primary', {
            't-text-primary t-opacity-100': align === 'center',
            't-text-muted': align !== 'center',
          })}
          onClick={() => setAlign('center')}
        />
      </span>
      <span title='Align Right'>
        <FaAlignRight
          size={18}
          className={classNames('t-cursor-pointer t-opacity-80 t-transition hover:t-text-primary', {
            't-text-primary t-opacity-100': align === 'right',
            't-text-muted': align !== 'right',
          })}
          onClick={() => setAlign('right')}
        />
      </span>
    </div>
  );
};

export default FontAlignment;
